import {DeviceProvide} from "@hybird/core/device/provide";
import {
  MqttDeviceProtocol,
  MqttDeviceProtocolBeginSeal,
  MqttDeviceProtocolOperation
} from "@hybird/device/protocol/mqtt";
import {BleDeviceProtocol, BleDeviceProtocolBeginSeal, BleDeviceProtocolOperation} from "@hybird/device/protocol/ble";
import {DeviceType} from "@hybird/device/config";
import {WebError} from "@hybird/core/error";
import {deviceError} from "@hybird/device/deviceError";
import {CompositeDeviceProtocol, defaultResult, DeviceEvent} from "@hybird/core/device/protocol";

class ADeviceProvide extends DeviceProvide {

  _deviceProtocols = {
    2: AMqttDeviceProtocol,
    1: ABleDeviceProtocol,
    3: ACompositeDeviceProtocol
  };

  constructor(deviceConnectProvide) {
    super(deviceConnectProvide);
  }

  isSupport(deviceInfo) {
    return DeviceType.a === deviceInfo.modelType;
  }
}

class AMqttDeviceProtocol extends MqttDeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  _createDeviceProtocolBeginSeal(option) {
    return new AMqttDeviceProtocolBeginSeal(this.deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new AMqttDeviceProtocolOperation(this.deviceInfo, this);
  }
}

class AMqttDeviceProtocolBeginSeal extends MqttDeviceProtocolBeginSeal {
  constructor(deviceInfo, deviceProtocol, option) {
    super(deviceInfo, deviceProtocol, option);
  }
}

class AMqttDeviceProtocolOperation extends MqttDeviceProtocolOperation {
  constructor(deviceInfo, deviceProtocol) {
    super(deviceInfo, deviceProtocol);
  }
}

class ABleDeviceProtocol extends BleDeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  _createDeviceProtocolBeginSeal(option) {
    return new ABleDeviceProtocolBeginSeal(this.deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new ABleDeviceProtocolOperation(this.deviceInfo, this);
  }

  /**
   * 同步指纹等数据
   * @return {Promise<{code,data,success}>} 无返回值
   * @private
   */
  async _sync(data) {
    this.emit(DeviceEvent.SYNC_STATUS, {progress: 1, type: 1, data: defaultResult});
    return defaultResult;
  }
}

class ABleDeviceProtocolBeginSeal extends BleDeviceProtocolBeginSeal {
  constructor(deviceInfo, deviceProtocol, option) {
    super(deviceInfo, deviceProtocol, option);
  }
}

class ABleDeviceProtocolOperation extends BleDeviceProtocolOperation {
  constructor(deviceInfo, deviceProtocol) {
    super(deviceInfo, deviceProtocol);
  }

  async wifiSetting({type, save = 1, ssid, password, success, complete, message, fail, timeout}) {
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT);
  }

  async wifiList({onWifi, success, complete, message, fail, timeout}) {
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT);
  }

  async fingerprintOperation({type, staffId, success, complete, message, fail, timeout} = {}) {
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT);
  }
}

class ACompositeDeviceProtocol extends CompositeDeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  get connectPromiseType() {
    return 2;
  }

  get deviceProtocols() {
    return {
      2: AMqttDeviceProtocol, 1: ABleDeviceProtocol
    };
  }
}

export {ADeviceProvide};